import { trackEvent } from 'dibs-tracking';

type Args = {
    label: string;
    moduleIndex: number;
    totalModules: number;
};

export const trackModuleLocation = ({ label, moduleIndex, totalModules }: Args): void => {
    trackEvent({
        category: 'promo interaction',
        moduleLocation: `${moduleIndex + 1}/${totalModules}`,
        action: 'clicked homepage module',
        label,
    });
};
